import { render } from "./AppointmentCreateModal.vue?vue&type=template&id=5eb52d5e&scoped=true"
import script from "./AppointmentCreateModal.vue?vue&type=script&lang=js"
export * from "./AppointmentCreateModal.vue?vue&type=script&lang=js"

import "./AppointmentCreateModal.vue?vue&type=style&index=0&id=5eb52d5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb52d5e"]])

export default __exports__